
import React from 'react';

type ExerciseVideoProps = {
    uuid: string;
};


const ExerciseVideo: React.FC<ExerciseVideoProps> = ({ uuid }) => {
    const url = `https://app.kemtai.com/media/exercises/${uuid}/480p.webm`;

    return (    
         <div style={{
             position: 'fixed',
             top: '10px',
             right: '10px',
             zIndex: 1000,
             marginTop: '3rem',
         }}>
            <video 
                src={url} 
                autoPlay 
                loop
                muted
                height="240px"
            />
        </div>
    );
}

export default ExerciseVideo;